/* eslint-disable @typescript-eslint/no-explicit-any */
export type FieldUniqueIdentifier = string & {
  readonly __brand: "FieldUniqueIdentifier"
}

export interface CollectionSetting {
  queryAttributes?: string
  valueAttribute: string
  displayAttr: string
  placeholder?: string
  customOption?: (item: object) => string
  orderBy?: string
  filter_by?: string
  multiple?: boolean
  dependOn?: string
  dependencyFilterKey?: string
}

// ... other types and interfaces ...
export type ServiceName =
  | "DFE"
  | "CORE_TRANSFER_INPUT"
  | "CORE_EXPORT_INPUT"
  | "SF"
  | "B2G"
  | "TEO"
  | "ITEXT"
  | "ITEXT_INPUT"
  | "DOCS"
  | "XML"
  | "UNKNOWN"
  | "CORE_TRANSFER_RESPONSE"
  | "CORE_EXPORT_RESPONSE"
  | "CORE_PHYTO_INPUT"
  | "CORE_PHYTO_RESPONSE"
  | "PHYTO_PDF"
  | "SEARCH"
  | "G2G_IPPC_PHYTO_XML"
  | "G2G_UNCEFACT_XML"
  | "B2G_SUBMISSION_PHYTO_XML"
  | "B2G_SUBMISSION_PHYTO_ERROR_FIELD"
  | "B2G_SUBMISSION_AP_TRANSFER_XML"
  | "B2G_SUBMISSION_AP_EXPORT_XML"
  | "SUBMISSION_PREVIEW_AP_XML_PATH"
  | "SUBMISSION_PREVIEW_PHYTO_XML_PATH"

export type SearchFieldReresentation = {
  readonly collectionName: string
  readonly usePermissions?: boolean
  readonly collectionSettings?: CollectionSetting
}

export type SubmissionLayout = "AP_EXPORT" | "AP_TRANSFER" | "PHYTO_EXPORT"

type SimpleServicePath = { readonly path: string }
type LayoutKeyedServicePath = Readonly<
  Partial<Record<SubmissionLayout, SimpleServicePath>>
>

export type ServiceFieldRepresentation =
  | SimpleServicePath
  | LayoutKeyedServicePath

export const resolvePath = (
  rep: ServiceFieldRepresentation | undefined,
  layout?: SubmissionLayout,
): string | undefined => {
  if (!rep) return undefined
  if ("path" in rep) return rep.path
  if (layout) return rep[layout]?.path
  return undefined
}
export interface FieldDefinition {
  readonly fuid: FieldUniqueIdentifier
  readonly description?: string
  readonly serviceRepresentations: Readonly<
    Partial<Record<ServiceName, ServiceFieldRepresentation>>
  >
  readonly searchRepresentation?: Readonly<
    Partial<Record<SubmissionLayout, SearchFieldReresentation>>
  >
  readonly coreRepresentation?: Readonly<
    Partial<Record<SubmissionLayout, boolean>>
  >
}
export interface IRegistryGetter {
  get(key: FieldUniqueIdentifier): FieldDefinition | undefined
}
export interface IRegistryIterator {
  values(): IterableIterator<FieldDefinition>
}
export interface IFieldRegistry extends IRegistryGetter, IRegistryIterator {}
export type FieldDefinitionGetter = (
  fuid: FieldUniqueIdentifier,
) => FieldDefinition | undefined
export type DataConverter = (
  sourceData: Record<string, any>,
) => Record<string, any>
export type ServiceConverterFactory = (
  fromService: ServiceName,
  targetService: ServiceName,
  layout?: SubmissionLayout,
) => DataConverter
export type ConverterFactory = (
  registry?: IFieldRegistry,
) => ServiceConverterFactory

export type GetFieldPath = (fuid: FieldUniqueIdentifier) => string
export type GetServiceFieldPath = (
  serverName: ServiceName,
  layout?: SubmissionLayout,
) => GetFieldPath

export type StructureBuilder = (
  fuids: ReadonlyArray<FieldUniqueIdentifier>,
) => Record<string, any>
